export default __webpack_public_path__ + "static/media/t.f682bef9.mp3";